"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "meters",
    path: "/meters",
    component: "MeterBrowser"
});
let MeterBrowser = class MeterBrowser extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_dsParams = new core_1.ComponentValueCache(this, "dsParams", "MeterBrowser.dsParams");
    }
    getQueryParameters(...args) {
        if (this.dsParams.actives_only) {
            return { skip_inactive: 'true' };
        }
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    dsParams;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('list_meter', { parameters: this.getQueryParameters });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                dsParams: {
                    actives_only: true,
                },
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "serial_number",
                        name: this.$fn.pgettext("MeterBrowser", "Serial Number"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "meter",
                            params: {
                                id: "id",
                            },
                        },
                    },
                    {
                        field: "main_meter_serial",
                        name: this.$fn.pgettext("MeterBrowser", "Main Meter"),
                        formatter: {
                            name: "routeLink",
                            to: "meter",
                            navigateOnIconClick: true,
                            params: {
                                id: "main_meter_id",
                            },
                        },
                    },
                    {
                        field: "inactive",
                        name: this.$fn.gettext("Inactive"),
                        textAlign: "center",
                        formatter: {
                            name: "checkbox",
                        },
                    },
                    {
                        field: "meter_type",
                        name: this.$fn.pgettext("MeterBrowser", "Meter type"),
                        formatter: {
                            name: "gettext",
                            context: "MeterTypes",
                            conversion: "Sentence",
                            filterInput: true,
                        },
                    },
                    {
                        field: "tag_id",
                        name: this.$fn.pgettext("MeterBrowser", "Tag ID"),
                    },
                    {
                        field: "deveui",
                        name: this.$fn.pgettext("MeterBrowser", "DevEUI"),
                    },
                    {
                        field: "unit",
                        name: this.$fn.pgettext("MeterBrowser", "Unit"),
                    },
                    {
                        field: "multiplier",
                        name: this.$fn.pgettext("MeterBrowser", "Mt."),
                        type: "number",
                    },
                    {
                        field: "site_name",
                        name: this.$fn.pgettext("MeterBrowser", "Site"),
                        formatter: {
                            name: "routeLink",
                            to: "property",
                            navigateOnIconClick: true,
                            params: {
                                id: "site_id",
                            },
                        },
                    },
                    {
                        field: "description",
                        name: this.$fn.pgettext("MeterBrowser", "Description"),
                    },
                    {
                        field: "model_name",
                        name: this.$fn.pgettext("MeterBrowser", "Model"),
                    },
                    {
                        field: "valid_from",
                        name: this.$fn.pgettext("MeterBrowser", "Valid From"),
                        type: "date",
                    },
                    {
                        field: "valid_to",
                        name: this.$fn.pgettext("MeterBrowser", "Valid To"),
                        type: "date",
                    },
                    {
                        field: "groups",
                        name: this.$fn.pgettext("MeterBrowser", "Groups"),
                        formatter: {
                            name: "join",
                            separator: ", ",
                        },
                    },
                    {
                        field: "rentals",
                        name: this.$fn.pgettext("MeterBrowser", "Rentals"),
                        toolTip: this.$fn.pgettext("MeterBrowser", "Current rentals"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            separator: ", ",
                            formatterContext: "item",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "name",
                                        source: "value",
                                    },
                                },
                                {
                                    name: "routeLink",
                                    to: "rental",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "tenants",
                        name: this.$fn.pgettext("MeterBrowser", "Tenants"),
                        toolTip: this.$fn.pgettext("MeterBrowser", "Current tenants"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            separator: ", ",
                            formatterContext: "item",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "name",
                                        source: "value",
                                    },
                                },
                                {
                                    name: "routeLink",
                                    to: "company",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "latest_reading_date",
                        name: this.$fn.pgettext("MeterBrowser", "Lr. date"),
                        toolTip: this.$fn.pgettext("MeterBrowser", "Latest reading date"),
                        type: "date",
                    },
                    {
                        field: "latest_reading_value",
                        name: this.$fn.pgettext("MeterBrowser", "Lr."),
                        toolTip: this.$fn.pgettext("MeterBrowser", "Latest reading"),
                        type: "number",
                    },
                    {
                        field: "latest_invoice_reading_date",
                        name: this.$fn.pgettext("MeterBrowser", "L inv. date"),
                        toolTip: this.$fn.pgettext("MeterBrowser", "Latest invoiced reading date"),
                        type: "date",
                    },
                    {
                        field: "latest_invoice_reading_value",
                        name: this.$fn.pgettext("MeterBrowser", "L inv. r."),
                        toolTip: this.$fn.pgettext("MeterBrowser", "Latest invoiced reading"),
                        type: "number",
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("MeterBrowser", "Meters"),
                icon: this.$config.meter.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3582_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_3584_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_3586_getActionArgs($event) {
        return {
            name: "CreateMeter",
        };
    }
    async evh_8320016629450276_click(event, scope) {
        return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3582 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3582_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3581 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3582,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3581],
        });
        const act_2248226175642056_setData_3584 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_3584_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_3583 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_3584,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_3583],
        });
        const act_8320016629450276_showModal_3586 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_3586_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_click_3585 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_3586,
            event: "click",
            displayName: "showModal",
        });
        const evh_8320016629450276_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_click_3585],
        });
        return {
            act_7315092382398562_closeModal_3582,
            evh_7315092382398562_close_3581,
            evh_7315092382398562_close,
            act_2248226175642056_setData_3584,
            evh_2248226175642056_selectedRowsChanged_3583,
            evh_2248226175642056_selectedRowsChanged,
            act_8320016629450276_showModal_3586,
            evh_8320016629450276_click_3585,
            evh_8320016629450276_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], MeterBrowser.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MeterBrowser.prototype, "onSize", null);
MeterBrowser = __decorate([
    (0, vue_property_decorator_1.Component)()
], MeterBrowser);
exports.default = MeterBrowser;
vue_property_decorator_1.Vue.component("MeterBrowser", MeterBrowser);
